import React from 'react';
import { Card, CardBody, Div, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import { SpecialityItemProps } from './speciality-item.props';
import Link from 'next/link';
import { useDispatch } from 'react-redux';
import { UsersActions } from '@store/users/users-action';
import getParseRoute from '@utils/helpers/parse-route';
import routes from '@routes';
import { useParams } from 'next/navigation';
import { LocaleTypes } from '@dictionaries-types';

const SpecialityItem = (props: SpecialityItemProps) => {
  const dispatch = useDispatch();
  const { id, title, src } = props;
  const { lang } = useParams<{lang: LocaleTypes}>();
  return (
    <Link
      passHref={true}
      tabIndex={-1}
      onClick={() => {
        dispatch(UsersActions.setFilterItems({ key: 'specialtiesType', id: id, value: title }));
      }}
      href={getParseRoute({ pathname: routes['route.users.index'], locale: lang })}>
      <Card className={'group w-28 h-32 sm:w-32 sm:h-40 md:w-36 md:h-44 my-2 border border-control-200 hover:border-tertiary mb-10 sm:mb-0'}>
        <CardBody className={'justify-around items-center'}>
          <Div className={'object-contain relative w-14 h-14 md:w-20 md:h-20'}>
            <Image
              alt={title}
              src={src}
              sizes={'(max-width: 639px) 33vw, (max-width: 1023px) 20vw, 5vw'}
            />
          </Div>
          <Text className={'group-hover:text-tertiary'} typography={'sm'} type={'bold'}>
            {title}
          </Text>
        </CardBody>
      </Card>
    </Link>
  );
};

export default SpecialityItem;
